import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ThumbUp = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.72581 2.01449C9.21432 1.75049 8.58884 1.86789 8.2079 2.2994L5.16167 5.75001H3C2.30964 5.75001 1.75 6.30965 1.75 7.00001V13C1.75 13.6904 2.30964 14.25 3 14.25H11.1241C11.6033 14.25 12.0402 13.9761 12.2491 13.5449L14.075 9.77538C14.1902 9.53757 14.25 9.27675 14.25 9.01251V6.90323C14.25 6.21288 13.6904 5.65323 13 5.65323H9.94051L10.3829 3.36974C10.489 2.8222 10.2214 2.27028 9.72581 2.01449ZM6.25 6.7837L8.74008 3.96307L8.29494 6.26058C8.25235 6.48039 8.3102 6.70774 8.45268 6.88047C8.59515 7.0532 8.80734 7.15323 9.03125 7.15323H12.75V9.01251C12.75 9.05026 12.7415 9.08751 12.725 9.12149L10.9674 12.75H6.25V6.7837ZM4.75 7.25001H3.25V12.75H4.75V7.25001Z"
      fill="currentColor"
    />
  </Icon>
));

export default ThumbUp;
